export const PATHS = {
  // Landing page
  LANDING: "/",

  // Profile page
  PROFILE: "/profile",
} as const;

export const PATH_SEGMENTS = {
  LANDING: "/",
  PROFILE: "/profile",
} as const;
